import { createRoute, retainSearchParams } from '@tanstack/react-router';
import { z } from 'zod';

import { rootRoute } from '../../router/routes/rootRoute';

import { viewClientReasonSchema } from './viewClientReasonSchema';

export const clientRoute = createRoute({
	path: '/client/$clientPidUuid',
	getParentRoute: () => rootRoute,
	validateSearch: z.object({
		viewReason: viewClientReasonSchema.optional().catch(undefined),
	}),
	search: {
		middlewares: [retainSearchParams(['viewReason'])],
	},
});
